import { PaginatedResponse } from '../models/PaginatedResponse.model'

/**
 * @description Compares two records by name for alphabetical lists: case-insensitive, with numbers in natural order
 * ("Trail 2" before "Trail 10").
 */
export const compareByName = (a: { name?: string | null }, b: { name?: string | null }): number =>
  (a.name ?? '').localeCompare(b.name ?? '', undefined, { numeric: true, sensitivity: 'base' })

/**
 * @description Returns a copy of a search response with its records sorted by name. Meant for react-query's `select`
 * option so dropdowns list options alphabetically without changing the cached response other screens share.
 */
export const sortResponseByName = <T extends { name?: string | null }>(
  response: PaginatedResponse<T>,
): PaginatedResponse<T> => ({ ...response, data: [...response.data].sort(compareByName) })
